import React, { useEffect, useState } from 'react'
import { toast } from 'react-toastify';
import CustomModal from '../constants/CustomModal'
import { apiService } from '../constants/ApiService'
import {
    Card,
    Row,
    Col,
    CardTitle,
    CardBody,
    Button,
    Form,
    FormGroup,
    Label,
    Input,
    FormText,
    Table
} from "reactstrap";
import { useSelector } from 'react-redux';


const CustomerAddHelperMaster = (props) => {

    const { user } = useSelector((state) => state.authState);
    const [errorMessage, setErrorMessage] = useState('');

    let initial = {
        form_name: "",
        field_name: "",
        field_data: "",
        deleted: 0,
        vendor_master_id: props?.branchMasterId ? props?.branchMasterId : null,
        branch_master_id: props?.branchMasterId ? props?.branchMasterId : null,
        system_generate: user.user_profile == "superadmin" ? "yes" : "no",
        display_option: "yes"
    }

    const [helperData, setHelperData] = useState(initial);
    // const [venderMaster, setVenderMasterTable] = useState([]);
    // const [branchMaster, setBranchMasterTable] = useState([]);

    const onChangeHandle = (e) => {
        const { name, value, type } = e.target;
        setHelperData((prevData) => ({
            ...prevData,
            [name]: value,
        }));
    };
    


    //vali
    const validateInputs = () => {
        const errors = {};

        // if (!helperData.vendor_master_id) {
        //     errors.vendor_master_id = 'Vendor is required';
        // }

        // if (!helperData.branch_master_id) {
        //     errors.branch_master_id = 'Branch is required';
        // }

        if (!helperData.form_name) {
            errors.form_name = 'From Name is required';
        }

        if (!helperData.field_name) {
            errors.field_name = 'Field Name is required';
        }

        if (!helperData.field_data) {
            errors.field_data = 'Field Data is required';
        }

        if (user.user_profile == "superadmin" && !helperData.working_bussinesss_mode) {
            errors.working_bussinesss_mode = "Working Business is required"
        }

        // if (!helperData.display_option) {
        //     errors.display_option = 'Display  is required';
        // }

        return errors;
    };

    const AddHelperData = async () => {

        const errors = validateInputs();
        if (Object.keys(errors).length > 0) {
            setErrorMessage(errors);
            return;
        } else {
            setErrorMessage("")
        }


        try {
            let config = {
                headers: {
                    'Content-Type': 'application/json',
                    'accept': 'application/json'
                }
            };



            const response = await apiService.post(`api/HelperMaster/create`, helperData, config)
            if (response.response && response.response.data.errors) {
                toast.success(response.response?.data?.errors);
            }

            if (response.status === true) {
                toast.success(response.message);
                setHelperData(initial)

                if (props && typeof props.fetchHelperData == 'function') {
                    props?.fetchHelperData()
                    props?.closedModel()
                }


            }
            else {
                toast.success(response.message);
            }
        } catch (error) {
            console.log(error)
            toast.error(`SomeThing went wrong!!`);
        }
    };

    const onHandleBackFilter = () => {
        props.closedModel()
    }

    useEffect(() => {
        setHelperData((prevData) => ({
            ...prevData,
            "form_name": props.fromName,
            // field_name: "",
            // field_data: "",
        }));
    }, [props.fromName])





    return (
        <>
            <CustomModal show={props.show} title={"Add Item Master detail"}
                size="md"
                content={
                    <>  <Row>
                        <Col>
                            {/* <Card className='bg-white pd-10 card-box mb-30'> */}
                            <CardTitle tag="h6" className="border-bottom p-3 mb-0 d-flex align-items-center justify-content-between">
                                <div className="d-flex align-items-center">
                                    <i className="bi bi-bell mr-2"></i>
                                    Helper Master
                                </div>

                                <Button color="danger" size="bg" onClick={onHandleBackFilter} className="ml-auto">
                                    Closed
                                </Button>
                            </CardTitle>
                            <CardBody>
                                <Form>
                                    <Row>
                                        <Col md-3 xl={6}>
                                            <FormGroup>
                                                <Label for="from_name" >Flag</Label>

                                                <Input 
                                                    id="form_name"
                                                    name="form_name"
                                                    onChange={(e) => { onChangeHandle(e) }}
                                                    value={helperData?.form_name}
                                                    type="text"
                                                    disabled
                                                />

                                                {errorMessage.form_name && (
                                                    <FormText color="danger">{errorMessage.form_name}</FormText>
                                                )}
                                            </FormGroup>

                                        </Col>
                                        <Col xl={6}>
                                            <Label for="field_name">Label Detail</Label>
                                            <Input 
                                                type="text"
                                                name="field_name"
                                                id="field_name"
                                                onChange={(e) => { onChangeHandle(e) }}
                                                value={helperData?.field_name}
                                            />
                                            {errorMessage.field_name && (
                                                <FormText color="danger">{errorMessage.field_name}</FormText>
                                            )}
                                        </Col>

                                    

                                    <Col xl={6}>
                                        <Label for="field_data">Value Data</Label>
                                        <Input 
                                            type="text"
                                            name="field_data"
                                            id="field_data"
                                            value={helperData.field_data}
                                            onChange={(e) => { onChangeHandle(e) }}
                                        />
                                        {errorMessage.field_data && (
                                            <FormText color="danger">{errorMessage.field_data}</FormText>
                                        )}
                                    </Col>
                                    {user.user_profile == "superadmin" &&
                                        <Col xl={6}>
                                            <Label for="working_bussinesss_mode">Working Business Option</Label>
                                            <Input 
                                                type="select"  className="custom-select"
                                                name="working_bussinesss_mode"
                                                id="working_bussinesss_mode"
                                                value={helperData.working_bussinesss_mode}
                                                onChange={(e) => { onChangeHandle(e) }}
                                            >
                                                <option value="">Select</option>
                                                {props.helperMasterWorkBussinessTable.map((option) => (
                                                    <option key={option.id} value={option.field_data}>
                                                        {option.field_name}
                                                    </option>
                                                ))}
                                            </Input>

                                            {errorMessage.working_bussinesss_mode && (
                                                <FormText color="danger">{errorMessage.working_bussinesss_mode}</FormText>
                                            )}
                                        </Col>}
                                        </Row>


                                    <Button type="button" className="mt-2" color="primary" onClick={() => AddHelperData()}>Save</Button>
                                </Form>
                            </CardBody>

                            {/* </Card> */}
                        </Col>
                    </Row>
                    </>
                } />
        </>
    )
}

export default CustomerAddHelperMaster